// extracted by mini-css-extract-plugin
export default {"Container":"ppt_Container__c0Aq-","backdrop":"ppt_backdrop__xl9JN"};